import { IFileModel } from "../global/file/File.model";
import { ICountry } from "../global/localization/country/ICountry.model";
import { ICasSpecialRepondant } from "./CasSpecialRepondant.model";

export enum FICHE_REPONDANT_LANGUE {
  FR = 'FR',
  EN = 'EN'
}

export enum FICHE_REPONDANT_STATUT {
  EN_ATTENTE = "EN_ATTENTE",
  VALIDEE = "VALIDEE",
  NON_CONFORME = "NON_CONFORME",
  EN_TRAITEMENT = "EN_TRAITEMENT",
  EN_ARRET = "EN_ARRET"
}

export interface IFicheRepondantModel {
  id:                      number;
  createdAt:               string;
  createdBy:               string;
  createdByFullName:       string;
  updatedAt:               string;
  updatedBy:               string;
  updatedByFullName:       string;
  version:                 number;
  idEtudiant:              number;
  idSession:               number;
  pays:                    ICountry;
  ville:                   string;
  prenom:                  string;
  nom:                     string;
  fonction:                string;
  telephonePrincipal:      string;
  courriel:                string;
  langue:                  FICHE_REPONDANT_LANGUE;
  employeurNom:            string;
  employeurAdresse:        string;
  employeurPreuveUrl:      string;
  statut:                  string;
  isModifiableParEtudiant: boolean;
  isSupprimableParEtudiant: boolean;
  isActif:                 boolean;
  employeurPreuveFichiers: Array<IFileModel>;
  casSpeciauxRepondant: Array<ICasSpecialRepondant>;
}